import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import {
    Agenda, Day, DragAndDrop, Inject, Month, Resize, ResourceDirective,
    ResourcesDirective, ScheduleComponent, TimelineViews, ViewDirective, ViewsDirective, Week, WorkWeek
} from '@syncfusion/ej2-react-schedule';
import React, { useEffect, useRef, useState } from 'react';
import { isClubOwner, isClubStaff, isUser } from "../../util/UserRoles"
import EditorFooterTemplate from './EditorFooterTemplate';
import EditorTemplateDesign from './EditorTemplateDesign';
import { onActionBegin, onActionComplete, onEventClick, onPopupOpen, onSingleClick } from './ScheduleActions';

import { useDispatch, useSelector } from 'react-redux';
import { calenderAction } from '../../redux/reducer/calenderReducer';

import Loader from '../../component/Loader';
import { createWorkingDays, getMaximunmTimeInADay, handleTimeOparetionsPerDay, setInitialStartAndEndHour } from '../../util/CalendarUtil';
import { CalendarAPI } from '../../api/CalendarAPI';
import { UserAPI } from '../../api/UserAPI';
import { SubscriptionAPI } from '../../api/SubscriptionAPI';
import { ProductAPI } from '../../api/ProductAPI';
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Slide, TextField } from '@mui/material';
import { PaymentAPI } from '../../api/PaymentAPI';
import PopUpAlert from '../../component/PopUpAlert';
import { PrivilegeAPI } from '../../api/PrivilegesAPI'
import { Privileges } from '../../util/PrivilegeConstants';
import { rootAction } from '../../redux/reducer/rootReducer';

let dialogObj;

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
const Calender = () => {
    const scheduleRef = useRef(null);
    const dispatch = useDispatch();
    const [loadingCount, setLoadingCount] = useState(0);
    const [selectedDate, setSelectedDate] = useState();
    const [currentSelectedDate, setCurrentSelectedDate] = useState(scheduleRef?.current?.getCurrentViewDates());
    const [privileges, setPrivileges] = useState({});
    // let currentSelectedDate = scheduleRef?.current?.getCurrentViewDates();
    const startLoading = () => {
        setLoadingCount(prevCount => prevCount + 1);
    };
    const finishLoading = () => {
        setLoadingCount(prevCount => prevCount - 1);
    };
    const isPaymentDoneForReservation = useSelector((store) => store.root.isPaymentDoneForReservation);
    const {
        currentView, weekDayStartTime, scheduleData, weekDayEndTime, calenderConfig, dayStartTime,
        dayEndTime, currentGameId, players, resourceData, courtNo, game, startHour, endHour, isUserValidToAccess, advanceBookingDay, openRefundPopup, refundAmount, refundReason, reservationId
    } = useSelector((store) => store.calendar);


    const [changeGame, setChangeGame] = useState(false);
    const [workDays, setWorkDays] = useState([]);

    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);


    const findAllPrivileges = async () => {
        try {
            startLoading()
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[6]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);

        } catch (error) {
            console.error(error);
        } finally {
            finishLoading();
        }
    };

    useEffect(() => {
        if (userInfo.userId) {
            findAllPrivileges();
        }
    }, [userInfo.userId])


    useEffect(() => {
        if (scheduleRef && scheduleRef.current) {
            setCurrentSelectedDate(scheduleRef?.current?.getCurrentViewDates())
        }
    }, [scheduleRef?.current, currentSelectedDate, dayStartTime, workDays])


    useEffect(() => {

        const fetchIsSubscriptionPurchased = async () => {
            try {
                startLoading();
                const res = await SubscriptionAPI.isSubscriptionPurchased(userInfo?.userId, selectedClub?.clubId);
                dispatch(calenderAction.setIsUserValidToAccess(!res.Data));

                finishLoading();
            } catch (error) {
                finishLoading();
            }
        }
        const fetchAllAPI = async () => {
            try {
                startLoading()
                const apiCalls = [
                    CalendarAPI.getCalendarConfig(selectedClub?.clubId),
                    CalendarAPI.getAllResourceAndGame({ clubId: selectedClub?.clubId }),
                    UserAPI.getAllUsersForAClub(selectedClub?.clubId),
                ];
                if (isUser(userInfo)) {
                    apiCalls.splice(apiCalls.length, 0, ProductAPI.getAdvanceBooking(userInfo?.userId, selectedClub?.clubId)); // Add it at the desired index
                }

                const [
                    calendarConfig,
                    allGames,
                    allUsersForAClub,
                    advanceBooking = null,
                ] = await Promise.allSettled(apiCalls);


                // Extract responses based on the presence of getAdvanceBooking
                if (calendarConfig.status === "fulfilled") {
                    dispatch(calenderAction.setCalenderConfig(calendarConfig.value.Data));
                }
                if (advanceBooking && advanceBooking.status === "fulfilled") {
                    dispatch(calenderAction.setAdvanceBookingDay(advanceBooking.value ? advanceBooking.value.Data : 0));
                }
                if (allGames.status === "fulfilled") {
                    dispatch(calenderAction.setCurrentGameId(allGames.value.Data.games[0]?.gameId))
                    dispatch(calenderAction.setGame(allGames.value.Data.games));
                    let data = allGames.value.Data.resources;
                    const result = data?.map((item) => ({
                        Name: item?.courtNumber,
                        Id: item?.id,
                        Color: item?.color,
                    }));
                    dispatch(calenderAction.setResourceData(result));
                    dispatch(calenderAction.setCourtNo(data));
                }
                if (allUsersForAClub.status === "fulfilled") {
                    dispatch(calenderAction.setPlayers(allUsersForAClub.value.Data));
                }

                finishLoading()
            } catch (error) {
                finishLoading()
            }

        }

        if (selectedClub?.clubId) {
            fetchAllAPI();
            fetchIsSubscriptionPurchased();
        }
    }, [selectedClub?.clubId]);

    useEffect(() => {

        if (calenderConfig) {
            setWorkDays(createWorkingDays(calenderConfig));
            setInitialStartAndEndHour(dispatch, calenderConfig);
            setSelectedDate(new Date(new Date().toLocaleString('en-US', { timeZone: calenderConfig.calenderTimezone })))
        }
    }, [calenderConfig, selectedClub.clubId])
    //FETCH COURT NUMBERS AND SCHEDULES
    useEffect(() => {

        const fetchSchedulesForDay = async () => {
            try {
                startLoading();
                const data = {
                    gameId: currentGameId,
                    startTime: dayStartTime,
                    endTime: dayEndTime,
                    clubId: selectedClub?.clubId,
                    clientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                }
                const response = await CalendarAPI.getAllReservationsPost(data);

                const result = response.Data?.map((item) => ({
                    Id: item?.reservationId,
                    Subject: item.reservationStatus === 'IN-PROGRESS' ? item.reservationStatus?.replace('-', ' ') : item.reservationStatus,
                    StartTime: item?.isAllDay ? new Date(new Date(item.startTime).toLocaleString('en-US', { timeZone: 'UTC' })) : item.startTime,
                    EndTime: item?.isAllDay ? new Date(new Date(item.endTime).toLocaleString('en-US', { timeZone: 'UTC' })) : item.endTime,
                    IsAllDay: item?.isAllDay,
                    IsReadonly: item?.reservationCreatedBy?.trim() !== userInfo?.userId?.trim() && !isClubOwner(userInfo) && !isClubStaff(userInfo),
                    Description: item?.description,
                    Player: item?.player.map((val) => val.id),
                    CourtNumber: item?.courtNo[0]?.id,
                    CreatedDate: item?.createdDate,
                    Amount: item?.amount,
                    IsFree: item?.amount === '0'
                    // RecurrenceRule: item?.recurrenceRule
                }));
                setTimeout(() => {
                    dispatch(calenderAction.setScheduleData(result));
                    finishLoading();

                }, 500);
            } catch (error) {
                finishLoading();
            }
        }
        const fetchSchedulesForWeek = async () => {
            try {
                startLoading();
                const data = {
                    gameId: currentGameId,
                    startTime: weekDayStartTime,
                    endTime: weekDayEndTime,
                    clubId: selectedClub.clubId,
                    clientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                }
                const response = await CalendarAPI.getAllReservationsPost(data);
                const result = response.Data?.map((item) => ({
                    Id: item?.reservationId,
                    Subject: item.reservationStatus === 'IN-PROGRESS' ? item.reservationStatus?.replace('-', ' ') : item.reservationStatus,
                    StartTime: item?.isAllDay ? new Date(new Date(item.startTime).toLocaleString('en-US', { timeZone: 'UTC' })) : item.startTime,
                    EndTime: item?.isAllDay ? new Date(new Date(item.endTime).toLocaleString('en-US', { timeZone: 'UTC' })) : item.endTime,
                    IsAllDay: item?.isAllDay,
                    IsReadonly: item?.reservationCreatedBy?.trim() !== userInfo?.userId?.trim() && !isClubOwner(userInfo) && !isClubStaff(userInfo),
                    Description: item?.description,
                    Player: item?.player.map((val) => val.id),
                    CourtNumber: item?.courtNo[0]?.id,
                    Amount: item?.amount
                    // RecurrenceRule: item?.recurrenceRule
                }));
                dispatch(calenderAction.setScheduleData(result));
                finishLoading();
            } catch (error) {
                finishLoading();
            }
        }

        if (currentGameId) {

            if (currentView === 'Day' || currentView === 'TimelineDay') {
                if (new Date(currentSelectedDate && currentSelectedDate[0]).getDate() == new Date(dayStartTime).getDate()) {
                    fetchSchedulesForDay();
                }
                if (calenderConfig) {
                    handleTimeOparetionsPerDay(scheduleRef, dispatch, calenderConfig);
                }
            } else if (currentView === 'Week' || currentView === 'TimelineWeek') {
                fetchSchedulesForWeek();
                if (calenderConfig) {
                    getMaximunmTimeInADay(dispatch, calenderConfig);
                }
            }
            setChangeGame(false);
        }
    }, [selectedClub.clubId, currentSelectedDate, dayStartTime, weekDayStartTime, isPaymentDoneForReservation.type]);

    //DATA BINDING WITH SCHEDULER
    const eventSettings = { dataSource: scheduleData, ignoreWhitespace: true, enableMaxHeight: true }



    //GROUPING DATA
    const groupData = {
        resources: ['Resources']
    }

    //CHANGE GAME NAME
    const handleGameSelect = (e) => {
        dispatch(calenderAction.setCurrentGameId(e.target.value));
        setChangeGame(true);
    }


    const refreshAllTemplate = () => {
        scheduleRef.current.refreshTemplates();
    }

    const handleEventTemplate = (args) => {
        return (
            <div className='reservation_template_container'>
                <p>{args.Subject}</p>
            </div>
        )
    }

    // const getRecurrenceValue = () => {
    //     if (recObject.current) {
    //         const editorInstance = recObject.current;
    //         const value = editorInstance.properties?.value; // Use correct method
    //         return value;
    //     }
    // };

    const handleRefundAPI = async (event) => {
        event.preventDefault();
        dispatch(calenderAction.setOpenRefundPopup(false))
        try {
            const refundInfo = {
                userId: userInfo?.userId,
                clubId: selectedClub?.clubId,
                reservationId: reservationId,
                reason: refundReason,
                amount: refundAmount,
            }
            startLoading();
            const response = await PaymentAPI.postCreateRefund(refundInfo);
            dispatch(calenderAction.removeSchedule(reservationId));
            dispatch(rootAction.setWarningMessage({id:Date.now(), type: 'success', content: response.Data }));
            finishLoading();
        } catch (error) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Please contact customer support' }));
            finishLoading();
        }
    }
    if (scheduleRef.current) {
        scheduleRef.current.hideSpinner();
    }


    return (
        <>
            <div className="calender_container" data-testid="calendar-container">
                {currentGameId &&
                    <FormControl data-testid="calendar-game-dropdown" className='calender-game-dropdown' sx={{ m: 1 }}>
                        <InputLabel id="demo-simple-select-autowidth-label">Game</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={currentGameId || ''}
                            onChange={handleGameSelect}
                            autoWidth
                            label="Game"
                        >
                            {game?.map((item) => (
                                <MenuItem key={item.gameId} value={item.gameId}>
                                    {item.gameName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }

                {(selectedClub.clubId && calenderConfig && workDays.length != 0 && resourceData != null) &&
                    
                    <div className="scheduler" data-testid="calendar-scheduler">
                        {(isUserValidToAccess && !isClubStaff(userInfo)) &&
                            <div className='security-mask-on-schedule' data-testid="calendar-subscription-mask">
                                <p>To access the calendar, please purchase a subscription.</p>
                            </div>}
                        <ScheduleComponent
                            timezone='UTC'
                            selectedDate={selectedDate}
                            ref={scheduleRef}
                            // delayUpdate='true'
                            height='80vh'
                            currentView='Day'
                            eventSettings={eventSettings}
                            enableAllDayScroll={true}
                            showTimeIndicator={false}
                            showWeekend={false}
                            workDays={workDays}
                            startHour={startHour}
                            endHour={endHour}
                            allowDragAndDrop={false}
                            allowResizing={false}
                            actionComplete={(args) => { onActionComplete(args, scheduleRef, dispatch) }}
                            editorTemplate={(args) => <EditorTemplateDesign
                                args={args}
                                players={players}
                                courtNo={courtNo}
                                userId={userInfo?.userId}
                            />}
                            cellDoubleClick={(args) => { args.cancel = true }}
                            cellClick={(args) => { onSingleClick(args, scheduleRef, calenderConfig, resourceData, userInfo, advanceBookingDay, privileges) }}
                            popupOpen={(args) => { onPopupOpen(args, scheduleRef, userInfo, currentGameId, dispatch, selectedClub.clubId, calenderConfig, advanceBookingDay, startLoading, finishLoading) }} group={groupData}
                            eventClick={(args) => { onEventClick(args, calenderConfig, userInfo) }}
                            timeScale={{ interval: Number(calenderConfig?.interval) ? Number(calenderConfig.interval) : 30, slotCount: 1 }}
                            editorFooterTemplate={(args) => <EditorFooterTemplate args={args} privileges={privileges} />}
                            actionBegin={(args) => { onActionBegin(args, calenderConfig) }}>
                            <ViewsDirective>
                                <ViewDirective option='Day' eventTemplate={handleEventTemplate} />
                                <ViewDirective option='Week' />
                                <ViewDirective option='TimelineWeek' />
                                <ViewDirective option='TimelineDay' />
                            </ViewsDirective>
                            <ResourcesDirective>
                                <ResourceDirective field='CourtNumber' title='Court Number' name='Resources' textField='Name' idField='Id' colorField='Color' dataSource={resourceData} />
                            </ResourcesDirective>
                            <Inject services={[Day, Week, WorkWeek, Month, Agenda, DragAndDrop, Resize, TimelineViews]} />
                        </ScheduleComponent>
                        <br />
                        <br />
                        <br />
                    </div>
                }
                {loadingCount != 0 && <Loader />}
                <Dialog
                    open={openRefundPopup}
                    TransitionComponent={Transition}
                    keepMounted
                >
                    <DialogTitle sx={{ fontFamily: 'sans-serif', fontWeight: 600 }}>{"Send refund"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText component={'span'} sx={{ marginTop: 1 }} id="alert-dialog-slide-description">
                            <form className="reservation-refund-form" onSubmit={handleRefundAPI}>
                                <p>Refunds take 5-10 days to appear on a customer's statement. Fees for the original payment won't be returned, but there are no additional fees for the refund. </p>
                                <div className="reservation-refund-input">
                                    <TextField
                                        fullWidth
                                        className="reservation-amount-text-input"
                                        variant="outlined"
                                        name="firstName"
                                        value={refundAmount || ''}
                                        label="Amount *" />
                                    <FormControl
                                        fullWidth
                                        data-testid="game-dropdown" className='calender-game-dropdown'
                                    >
                                        <InputLabel id="demo-simple-select-autowidth-label">Reason</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={refundReason || ''}
                                            onChange={(e) => dispatch(calenderAction.setRefundReason(e.target.value))}
                                            label="Reason"
                                        >
                                            <MenuItem value="REQUESTED_BY_CUSTOMER">Request from customer</MenuItem>
                                            <MenuItem value="FRAUDULENT">Fraudulent</MenuItem>
                                            <MenuItem value="DUPLICATE">Duplicate</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="member-details-btn">
                                    <Button
                                        onClick={() => dispatch(calenderAction.setOpenRefundPopup(false))}
                                        color="error"
                                        variant="outlined">Cancel</Button>

                                    <Button
                                        type="submit"
                                        variant="contained">Refund</Button>
                                </div>
                            </form>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>

            </div>
        </>
    )
}

export default Calender